export default __webpack_public_path__ + "static/media/kelvin.1b01182a.jpg";